const DEFAULT_BEND_RADIUS = 5;

const getDistance = (x1, y1, x2, y2) =>
  Math.hypot(x2 - x1, y2 - y1);

/**
 * Draw a cable centreline with circular bends. Two adjacent 90 degree bends
 * form the semicircular return found at the end of a heating-mat cable loop.
 */
export const drawRoundedCablePath = (
  context,
  points,
  bendRadius = DEFAULT_BEND_RADIUS
) => {
  if (!points || points.length < 2) return;

  context.beginPath();
  context.moveTo(points[0], points[1]);

  for (let i = 2; i < points.length - 2; i += 2) {
    const previousX = points[i - 2];
    const previousY = points[i - 1];
    const cornerX = points[i];
    const cornerY = points[i + 1];
    const nextX = points[i + 2];
    const nextY = points[i + 3];

    const incomingLength = getDistance(
      previousX,
      previousY,
      cornerX,
      cornerY
    );
    const outgoingLength = getDistance(cornerX, cornerY, nextX, nextY);
    const crossProduct =
      (cornerX - previousX) * (nextY - cornerY) -
      (cornerY - previousY) * (nextX - cornerX);

    if (
      incomingLength === 0 ||
      outgoingLength === 0 ||
      Math.abs(crossProduct) < 0.0001
    ) {
      context.lineTo(cornerX, cornerY);
      continue;
    }

    const radius = Math.min(
      bendRadius,
      incomingLength / 2,
      outgoingLength / 2
    );
    context.arcTo(cornerX, cornerY, nextX, nextY, radius);
  }

  context.lineTo(points[points.length - 2], points[points.length - 1]);
};

export const createCableLine = (Konva, config) => {
  const { points, bendRadius = DEFAULT_BEND_RADIUS, ...shapeConfig } = config;

  return new Konva.Shape({
    ...shapeConfig,
    points,
    bendRadius,
    sceneFunc: (context, shape) => {
      drawRoundedCablePath(
        context,
        shape.getAttr("points"),
        shape.getAttr("bendRadius")
      );
      context.strokeShape(shape);
    },
  });
};

export { DEFAULT_BEND_RADIUS };
